module.exports = __webpack_public_path__ + "fonts/Manrope-SemiBold.be79203f.ttf";